import { render, staticRenderFns } from "./Paises.vue?vue&type=template&id=476a72b0&"
import script from "./Paises.vue?vue&type=script&lang=js&"
export * from "./Paises.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports